import { parse } from 'query-string';
import type { Match } from '@atlassian/react-resource-router';

export const Filters: {
	readonly myopenissues: symbol;
	readonly reportedbyme: symbol;
	readonly allopenissues: symbol;
	readonly doneissues: symbol;
	readonly recentlyviewed: symbol;
	readonly resolvedrecently: symbol;
	readonly updatedrecently: symbol;
	readonly allissues: symbol;
} = {
	myopenissues: Symbol('myopenissues'),
	reportedbyme: Symbol('reportedbyme'),
	allopenissues: Symbol('allopenissues'),
	doneissues: Symbol('doneissues'),
	recentlyviewed: Symbol('recentlyviewed'),
	resolvedrecently: Symbol('resolvedrecently'),
	updatedrecently: Symbol('updatedrecently'),
	allissues: Symbol('allissues'),
} as const;

const StatusCategoryValues = {
	TO_DO: '"To Do"',
	DONE: '"Done"',
	IN_PROGRESS: '"In Progress"',
} as const;

type ProjectKey = string;

const DEFAULT_SORT_DIRECTION = 'DESC';
const DEFAULT_ORDER_FIELD = 'created';

export const isFilterKey = (filter?: unknown): filter is keyof typeof Filters =>
	typeof filter === 'string' && filter in Filters;

export const mapFilterToJql = (projectKey: string, filter?: string): string | undefined => {
	if (!isFilterKey(filter)) {
		return undefined;
	}

	const clauses: string[] = [`project = "${projectKey}"`];
	let order: 'created' | 'lastviewed' | 'updated' = DEFAULT_ORDER_FIELD;
	const direction: 'ASC' | 'DESC' | 'NONE' = DEFAULT_SORT_DIRECTION;

	switch (Filters[filter]) {
		case Filters.myopenissues:
			clauses.push('assignee IN (currentUser())');

			clauses.push(
				`statusCategory IN (${StatusCategoryValues.TO_DO}, ${StatusCategoryValues.IN_PROGRESS})`,
			);
			break;
		case Filters.reportedbyme:
			clauses.push('reporter IN (currentUser())');
			break;
		case Filters.allopenissues:
			clauses.push(
				`statusCategory IN (${StatusCategoryValues.TO_DO}, ${StatusCategoryValues.IN_PROGRESS})`,
			);
			order = 'updated';
			break;
		case Filters.doneissues:
			clauses.push(`statusCategory = ${StatusCategoryValues.DONE}`);
			break;
		case Filters.recentlyviewed:
			order = 'lastviewed';
			break;
		case Filters.resolvedrecently:
			clauses.push('resolved >= -1w');
			order = 'updated';
			break;
		case Filters.updatedrecently:
			order = 'updated';
			break;
		case Filters.allissues:
			order = 'created';
			break;
		default:
	}

	return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};

export const getDefaultJql = (projectKey: ProjectKey): string =>
	`project = "${projectKey}" ORDER BY ${DEFAULT_ORDER_FIELD} ${DEFAULT_SORT_DIRECTION}`;

type ParsedParams = {
	[key: string]: string | string[] | undefined;
	projectKey: string | undefined;
	issueKey: string | undefined;
	filter: string | undefined;
	jql: string | undefined;
};

export const mergeParams = (search: string, match?: Match | null): ParsedParams => ({
	...parse(search),
	...(match && match.params),
});

export const getUrlPrefix = (url: string): string => {
	const match = url.match(/^(.*)\/projects.*$/);
	return (match && match[1]) ?? '';
};
